import Image from "next/image";
import routes from "@/constants/routes";

const LearnMore = () => (
  <section className="bg-white py-16 md:py-20">
    <div className="px-5 lg:px-20 mx-auto max-w-7xl">
      <h2 className="text-3xl md:text-5xl font-bold text-landing-blue text-center mb-3">
        Want to learn more about Keyzy?
      </h2>
      <p className="font-serif text-lg md:text-2xl text-landing-blue/70 text-center mb-10 md:mb-14">
        Chat to a real person, or read the detail at your own pace.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="rounded-[20px] p-9 md:p-10 flex flex-col gap-4 bg-[#25D366] text-white">
          <h3 className="text-2xl font-bold">Chat with us on WhatsApp</h3>
          <p className="text-base text-landing-lightGray  opacity-90 max-w-[32ch] h-14">
            Ask us anything about rent-to-own, eligibility or a specific home. We usually reply
            within the hour.
          </p>
          <a
            href="https://wa.me/447707053999"
            target="_blank"
            rel="noreferrer"
            className="self-start mt-4 w-[170px] inline-flex items-center gap-3 h-12 px-6 rounded-lg bg-white text-[#128C7E] font-bold hover:scale-105 transition-transform duration-300 ease-in-out"
          >
            <Image src="/icons/message.svg" alt="" width={20} height={20} />
            Message us
          </a>
        </div>

        <div className="rounded-[20px] p-9 md:p-10 flex flex-col gap-4 bg-landing-gray text-landing-blue">
          <h3 className="text-2xl font-bold">Read our FAQs</h3>
          <p className="text-base opacity-90 max-w-[32ch] h-14">
            The complete answers — deposits, fees, eligibility, buying and walking away.
          </p>
          <a
            href={routes.faqs}
            className="self-start mt-4 w-[170px] inline-flex items-center h-12 px-6 rounded-lg bg-landing-blue text-white font-bold hover:scale-105 transition-transform duration-300 ease-in-out"
          >
            Browse all FAQs
          </a>
        </div>
      </div>
    </div>
  </section>
);

export default LearnMore;
